import React from 'react'
import {
    Container, CssBaseline, Typography, Paper, Grid, Checkbox, FormControl,
    FormGroup, FormControlLabel, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@material-ui/core';
import logo from "./bg.jpg";
import { useHistory } from "react-router-dom";
export const Consent = (props) => {
    let history = useHistory();


    const handleSearch = (event) => {
        event.preventDefault();
        //   props.history.push('/register') 
        history.push('/register/accept');
    }
    return (
        <React.Fragment>
            <CssBaseline />
            <Container component="main" maxWidth="lg">
                <Paper style={{ padding: 20, marginTop: 20,marginBottom: 20 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} align="center">
                            <img
                                alt=""
                                src={logo}
                                width="100%"


                            />
                        </Grid>

                        <Grid item xs={12} >
                            <Typography variant="h6" color="primary">
                                1. คุณสมบัติผู้กู้
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >

                            <Typography variant="subtitle1" >
                                &nbsp; &nbsp; &nbsp; &nbsp;1.1  เป็นข้าราชการ  ลูกจ้างประจำ  พนักงานราชการ  และพนักงานรัฐวิสาหกิจที่สังกัดหน่วยงานที่มีข้อตกลงกับธนาคารออมสิน (ส่วนกลาง)
                                <br></br>
                                &nbsp; &nbsp; &nbsp; &nbsp;1.2  มีอายุครบ 20 ปีขึ้นไป และเมื่อรวมอายุผู้กู้กับระยะเวลาที่ชำระเงินกู้ต้องไม่เกิน 60  ปี  ยกเว้น ข้าราชการอัยการและข้าราชการตุลาการ เมื่อรวมอายุผู้กู้กับระยะเวลาชำระคืนเงินกู้ต้องไม่เกิน 70 ปี
                                <br></br>
                                &nbsp; &nbsp; &nbsp; &nbsp;1.3  เป็นผู้ฝากเงินประเภทเผื่อเรียกของธนาคารออมสิน
                                <br></br>
                                &nbsp; &nbsp; &nbsp; &nbsp;1.4  ณ วันยื่นกู้ต้องไม่มีภาระสินเชื่อสวัสดิการสำหรับข้าราชการและพนักงานรัฐวิสาหกิจ (ธนาคารออมสิน)
                            </Typography>

                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="h6" color="primary">
                                2. วัตถุประสงค์การกู้
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="subtitle1" >
                                &nbsp; &nbsp; &nbsp; &nbsp; เพื่อการอุปโภคบริโภค หรือชำระหนี้สินเชื่ออื่น ๆ


                            </Typography>


                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="h6" color="primary">
                                3. จำนวนเงินให้กู้
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="subtitle1" >
                                &nbsp; &nbsp; &nbsp; &nbsp;ให้กู้ได้สูงสุดไม่เกินรายละ 500,000 บาท


                            </Typography>


                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="h6" color="primary">
                                4. ระยะเวลาชำระเงินกู้
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="subtitle1" >
                                &nbsp; &nbsp; &nbsp; &nbsp;ให้กู้ได้ไม่เกิน 10 ปี


                            </Typography>


                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="h6" color="primary">
                                5. อัตราดอกเบี้ยเงินกู้
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >

                            <Typography variant="subtitle1" >
                                &nbsp; &nbsp; &nbsp; &nbsp; MRR - 0.25% ต่อปี (5.995%)  หรือ  MRR ต่อปี (6.245%)
                                <br></br>
                                &nbsp; &nbsp; &nbsp; &nbsp;ขึ้นอยู่กับเงื่อนไขข้อตกลงของแต่ละหน่วยงาน
                                <br></br>
                                &nbsp; &nbsp; &nbsp; &nbsp;ปัจจุบัน MRR = 6.245% ต่อปี (ตั้งแต่ 25 พฤษภาคม 2563)

                            </Typography>

                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="h6" color="primary">
                                6. หลักประกันการกู้เงิน
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="subtitle1" >
                                &nbsp; &nbsp; &nbsp; &nbsp;ไม่ต้องใช้บุคคลค้ำประกัน


                            </Typography>


                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="h6" color="primary">
                                7. ระยะเวลาดำเนินการ
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="subtitle1" >
                                &nbsp; &nbsp; &nbsp; &nbsp; จัดทำนิติกรรมสัญญาให้แล้วเสร็จภายในวันที่ 30 ธันวาคม 2564


                            </Typography>


                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="h6" color="primary">
                                8. อื่น ๆ
                            </Typography>
                        </Grid>
                        <Grid item xs={12} >
                            <Typography variant="subtitle1" >
                                &nbsp; &nbsp; &nbsp; &nbsp;หลักเกณฑ์เงื่อนไขอื่นที่มิได้กล่าวไว้เป็นไปตามเงื่อนไขที่ธนาคารกำหนด



                            </Typography>


                        </Grid>

                        <form autoComplete="off" onSubmit={handleSearch} style={{ marginTop: 15 }} >
                            <Grid item xs={12}>
                                <FormControl component="fieldset" >

                                    <FormGroup>
                                        <FormControlLabel
                                            control={<Checkbox required={true} color="primary" name="condition" />}
                                            label='ข้าพเจ้าตกลงให้ธนาคารออมสินรวมถึงพนักงานและตัวแทนของธนาคาร ทำการเก็บรวบรวมใช้ข้อมูลส่วนบุคคลของ   ข้าพเจ้าที่ให้ไว้กับธนาคาร และเปิดเผยให้แก่กลุ่มธุรกิจทางการเงินของธนาคาร บุคคล หรือหน่วยงานที่ธนาคารมอบหมาย เพื่อวัตถุประสงค์ดังต่อไปนี้'
                                        />

                                    </FormGroup>

                                </FormControl>
                            </Grid>
                            <Grid item xs={12} >

                                <Typography variant="subtitle1" >
                                    &nbsp; &nbsp; &nbsp; &nbsp;1.	เพื่อการรับรู้ข่าวสาร รวมถึงสิทธิพิเศษ การจัดกิจกรรม และการแจกของรางวัลต่าง ๆ
                                    <br></br>
                                    &nbsp; &nbsp; &nbsp; &nbsp;2.	เพื่อประโยชน์ของธนาคารในการเก็บรวบรวมข้อมูลนำมาวิเคราะห์และพัฒนาผลิตภัณฑ์ บริการ ข้อมูลทางการตลาด การส่งเสริมการขาย หรือการประชาสัมพันธ์ผลิตภัณฑ์และบริการต่าง ๆ ของธนาคาร ให้ตอบโจทย์ความต้องการและสร้างความพึงพอใจแก่ผู้ใช้บริการ


                                </Typography>
                                <Typography variant="subtitle1" color="primary">
                                    ** การลงทะเบียน เป็นการแจ้งความประสงค์เพื่อขอกู้สินเชื่อเท่านั้น ไม่ถือเป็นการรับสิทธิ์วงเงินโครงการแต่อย่างใด โดยการพิจารณาสินเชื่อเป็นไปตามหลักเกณฑ์ที่ธนาคารกำหนด **
                                </Typography>
                            </Grid>
                            <Grid item xs={12} align="center">

                                <Button

                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    style={{ marginTop: 15 }}
                                >
                                    ลงทะเบียน

                                </Button>

                            </Grid>
                        </form>
                    </Grid>




                </Paper>
            </Container>
        </React.Fragment>
    )
}
